import React from 'react'

import { BaseView } from '@/components/base'
import { useTheme } from '@/hooks/useTheme'

interface SkeletonCardProps {
  height?: number
  radius?: number
  align?: 'center' | 'flex-start' | 'flex-end'
}

export const SkeletonCard: React.FC<SkeletonCardProps> = ({
  height = 221,
  radius = 32,
  align = 'center',
}) => {
  const theme = useTheme()

  return (
    <BaseView
      rounded={radius}
      center={align === 'center'}
      style={{
        height: `${height}px`,
        backgroundColor: theme.colors.background.secondaryGray,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: align,
        gap: '20px',
        padding: '16px',
      }}
      className="animate-pulse"
    >
      {/* Title skeleton */}
      <div
        style={{
          width: '100px',
          height: '16px',
          backgroundColor: theme.colors.background.secondaryGrayOpacity01,
          borderRadius: '8px',
        }}
      />

      {/* Balance skeleton */}
      <div
        style={{
          width: '200px',
          height: '32px',
          backgroundColor: theme.colors.background.secondaryGrayOpacity01,
          borderRadius: '8px',
        }}
      />

      {/* Buttons skeleton */}
      <BaseView
        row
        gap={8}
        fullWidth
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: '20px',
        }}
      >
        <div
          style={{
            flex: 1,
            height: '40px',
            backgroundColor: theme.colors.background.secondaryGrayOpacity01,
            borderRadius: '20px',
          }}
        />
        <div
          style={{
            flex: 1,
            height: '40px',
            backgroundColor: theme.colors.background.secondaryGrayOpacity01,
            borderRadius: '20px',
          }}
        />
      </BaseView>
    </BaseView>
  )
}
